import { render, staticRenderFns } from "./ServerViewerClient.vue?vue&type=template&id=24650f3a&scoped=true"
import script from "./ServerViewerClient.vue?vue&type=script&lang=js"
export * from "./ServerViewerClient.vue?vue&type=script&lang=js"
import style0 from "./ServerViewerClient.vue?vue&type=style&index=0&id=24650f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24650f3a",
  null
  
)

export default component.exports